/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const TenantRole = {
    HR_MANAGER: 'HrManager',
    HC_MANAGER: 'HcManager',
    PZS_MANAGER: 'PzsManager',
    SYS_MANAGER: 'SysManager'
} as const;
export type TenantRole = typeof TenantRole[keyof typeof TenantRole];

